module.exports = __webpack_public_path__ + "img/result.96e9529c.png";